/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} InsertInputs */



/**
* | output |
* | --- |
* | "Insert" |
*
* @param {InsertInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert = /** @type {((inputs?: InsertInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<InsertInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Insertion")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserire")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставлять")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("入れる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डालना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir")
	return /** @type {LocalizedString} */ ("Insert")
});